<div class="popin-container relative">
  <div class="popin-header">
    <h1>{{ 'folder_selector.title' | translate }}</h1>
    <app-folder-selector-dialog-search-bar [searchCtrl]="searchCtrl">
      <div class="folders-container">
        <div class="p-1rem message-container"
             *ngIf="!(search$ | async).length">{{ 'folder_selector.no_folder_found' | translate }}</div>
        <app-folder-selector-dialog-folder *ngFor="let folder of search$ | async"
                                           [folder]="folder"
                                           (click)="onFolderSearchSelected(folder)"></app-folder-selector-dialog-folder>
      </div>
    </app-folder-selector-dialog-search-bar>

    <div class="custom-label">{{ 'folder_selector.selected_folder' | translate }}</div>

    <app-folder-selector-dialog-breadcrumb [backIsEnabled]="backIsEnabled$ | async"
                                           [path]="path$ | async"
                                           [folder]="folder$ | async"
                                           (onFolderBack)="onFolderBack()"
                                           (onFolderSelect)="onSelectFolder($event)">
      <app-button icon="add"
                  (onClick)="onCreateFolder()">{{ 'folder_selector.create_folder' | translate }}</app-button>
    </app-folder-selector-dialog-breadcrumb>
  </div>
  <div class="content">
    <div class="folders-actions">
      <div class="folders-sort-container">
        <div class="folder-sort"
             (click)="onFolderSort()">
          <span class="folder-sort-label">{{ 'folder_selector.name' | translate }}</span>
          <ng-container [ngSwitch]="order$ | async">
            <mat-icon *ngSwitchCase="'asc'">expand_less</mat-icon>
            <mat-icon *ngSwitchCase="'desc'">expand_more</mat-icon>
          </ng-container>
        </div>
      </div>
      <div class="folders-view-type-container">
        <mat-icon [ngClass]="{ selected: (viewType$ | async) === 'list' }"
                  (click)="onViewType('list')">list</mat-icon>
        <mat-icon [ngClass]="{ selected: (viewType$ | async) === 'grid' }"
                  (click)="onViewType('grid')">grid_view</mat-icon>
      </div>
    </div>
    <div class="p-1rem message-container"
         *ngIf="!(folders$ | async).length">{{ 'folder_selector.no_folder' | translate }}</div>
    <div class="folders-container"
         [ngClass]="{
        'folders-list': (viewType$ | async) === 'list',
        'folders-grid': (viewType$ | async) === 'grid'
       }">
      <app-folder-selector-dialog-folder *ngFor="let folder of folders$ | async"
                                         [folder]="folder"
                                         [viewType]="viewType$ | async"
                                         (click)="onSelectFolder(folder)"></app-folder-selector-dialog-folder>
    </div>
  </div>
  <div class="actions p-1rem">
    <app-button buttonType="mat-button"
                (click)="onClose()">{{ 'button.cancel' | translate }}</app-button>
    <app-button buttonType="mat-flat-button"
                (click)="onSubmit()"
                icon="check">{{ 'folder_selector.select_this_folder' | translate }}</app-button>
  </div>
</div>

